export default __webpack_public_path__ + "static/media/mallory_compact_x_light.5b9ee27c.ttf";